import React from 'react';
import PropTypes from 'prop-types';

import { MetricItemBase } from './MetricItem.styles';
import { Statistic } from '../Statistic/Statistic';
import { Trend } from '../Trend/Trend';
import { TextExtraLarge } from '../../common/text';
import deepEqual from 'fast-deep-equal';

export const avgHeading = '30 day avg.';
export const unitMWh = 'MWh';
export const unitMs = 'm/s';
export const unitH = 'h';
export const durationFormat = 'h[h] m[min]';

export class MetricItem extends React.Component {
    shouldComponentUpdate(nextProps) {
        return !deepEqual(this.props, nextProps);
    }

    render() {
        const { totalItem, totalItemWidth, avgItem, percentage, color } = this.props;
        let calculated;
        if (percentage && avgItem.value && totalItem.value) {
            const y1 = avgItem.value;
            const y2 = totalItem.value;

            if (y1 === 0) {
                calculated = 0;
            } else {
                calculated = Math.round(((y2 - y1) / y1) * 100);
            }
        }
        const hasTrend = calculated !== undefined;

        return (
            <MetricItemBase color={color} hasTrend={hasTrend} data-testid="metric-item">
                <Statistic
                    key="totalItem"
                    className="totalItem"
                    {...totalItem}
                    width={totalItemWidth ? totalItemWidth : 1}
                />
                {avgItem && (
                    <Statistic
                        key="avgItem"
                        className="avgItem"
                        {...avgItem}
                        dimmed
                        width={totalItemWidth ? 1 - totalItemWidth : 1}
                    />
                )}
                {hasTrend && <Trend className="percentage" value={calculated} textComponent={TextExtraLarge} />}
            </MetricItemBase>
        );
    }
}

MetricItem.displayName = 'MetricItem';

MetricItem.propTypes = {
    totalItem: PropTypes.object.isRequired,
    totalItemWidth: PropTypes.number,
    avgItem: PropTypes.object,
    percentage: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

MetricItem.defaultProps = {};
